(function (Drupal) {
  Drupal.behaviors.repositionSidebarAndFooter = {
    attach(context) {
      const pageWrapper = context.querySelector('#page-wrapper-with-sidebar');
      const sidebarRegion = context.querySelector('#floating-sidebar');
      const deptFooterBlock = context.querySelector(
        '#block-msu-drupal-deptfooterblock',
      );
      const footer = context.querySelector('footer.footer');

      // Function to move the sidebar into content area for text wrapping
      function moveSidebarIntoContent() {
        if (sidebarRegion && pageWrapper) {
          // Target the nested .section .section .layout structure where sidebar works best
          const layoutContainer = context.querySelector(
            '.section .section .layout',
          );
          const contentBody = context.querySelector('.content-item__body');
          const contentItem = context.querySelector('.content-item');
          const contentRegion = context.querySelector('.content_region');
          const targetContainer =
            layoutContainer || contentBody || contentItem || contentRegion;

          if (targetContainer && !targetContainer.contains(sidebarRegion)) {
            // Insert sidebar at the beginning of the layout container
            targetContainer.insertBefore(
              sidebarRegion,
              targetContainer.firstChild,
            );

            // Add a class to indicate sidebar has been moved
            sidebarRegion.classList.add('sidebar-injected');
          }
        }

        // Check if .sidebar_region has .sidebar-injected class and add .sidebar-injected-wrapped to parent .layout
        const sidebarRegionElement = context.querySelector(
          '.sidebar_region.sidebar-injected',
        );
        if (sidebarRegionElement) {
          const parentLayout = sidebarRegionElement.closest('.layout');
          if (parentLayout) {
            parentLayout.classList.add('sidebar-injected-wrapper');
          }
        }

        // Handle footer positioning as before
        if (deptFooterBlock && pageWrapper.contains(deptFooterBlock)) {
          pageWrapper.parentNode.insertBefore(
            deptFooterBlock,
            pageWrapper.nextSibling,
          );
        }

        if (footer && pageWrapper.contains(footer)) {
          pageWrapper.parentNode.insertBefore(
            footer,
            deptFooterBlock
              ? deptFooterBlock.nextSibling
              : pageWrapper.nextSibling,
          );
        }
      }

      moveSidebarIntoContent();

      // Optional: Use a MutationObserver to handle dynamic content changes
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'childList') {
            moveSidebarIntoContent();
          }
        });
      });

      observer.observe(pageWrapper, { childList: true, subtree: false });
    },
  };
})(Drupal);
